<template>
  <v-card
    max-width="450"
    class="mx-auto"
  >
    <v-card-title primary-title>
      <div class="text-h4">
        In- &amp; utpriser  
      </div>
      <v-spacer />         
    </v-card-title>       
    <v-card-subtitle>
      <v-currency-field v-model="price"      
                        label-class="text-h5"
                        class="text-h5" 
                        label="Försäljningspris"
                        :decimal-length="2" 
                        :auto-decimal-mode="false"
                        :error-messages="errors.rate"
                        currency="SEK"                        
                        locale="sv-SE"
                        filled        
      />
    </v-card-subtitle>
    <v-card-text>                 
      <v-list two-lines>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Moms på ursprung:  </v-list-item-title> 
            <v-list-item-title class="red--text bold">
              {{ momsUrsprung | toFixed(2) }} kr.
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Inköpspris:  </v-list-item-title> 
            <v-list-item-title class="red--text bold">
              {{ purchasePrice | toFixed(2) }} kr.
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Provision:  </v-list-item-title> 
            <v-list-item-title class="red--text bold">
              {{ provision | toFixed(2) }} kr.
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Moms (6%):   </v-list-item-title> 
            <v-list-item-title class="red--text bold">
              {{ moms | toFixed(2) }} kr.
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>        
      </v-list>      
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name:'Provision',
  data: () => ({
    price: 0,
    errors: {}
  }),
  computed:{
    momsUrsprung(){
      return (this.price*0.9434)
    },
    purchasePrice(){
      return (this.momsUrsprung-this.provision)
    },
    provision(){
      return (this.momsUrsprung*0.215)
    },
    moms(){
      return (this.purchasePrice*0.06)
    }
  }
}
</script>

<style>
.v-input__slot label {
    font-size: 0.8em;
}
.v-list-item__title{
  font-size: 1.4em;
}
</style>